module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.7372/img/storefront-header-blobs.svg"